define(["require", "exports", "jquery", "./formUtils", "./welcomeCredit"], function (require, exports, $, formUtils_1, welcomeCredit_1) {
    "use strict";
    exports.__esModule = true;
    function default_1(firstName, lastName, onCloseNavigate) {
        var dlgClassName = "welcome-credit-dialog";
        var $dlg = $(dlgClassName);
        var host = window.location.hostname;
        var registerUrl = (isLocalDev ? 'http' : 'https') + "://" + window.location.host + "/customer/info";
        if ($dlg.length === 0) {
            $dlg = $("<div class=\"" + dlgClassName + "\"><h3 class=\"title\">Welcome, please fill in your email address so we can deposit $5 store credit in your account</h3><form action=\"" + registerUrl + "\" method=\"post\"><input type=\"text\" name=\"Email\" placeholder=\"Email\"/><input type=\"hidden\" name=\"FirstName\" value=\"" + firstName + "\"/><input type=\"hidden\" name=\"LastName\" value=\"" + lastName + "\"/><button type=\"submit\" class=\"email-signup\">Get credits</button></form></div>");
            $dlg.appendTo($('body'));
            $dlg.find('.email-signup').click(function (evt) {
                evt.preventDefault();
                var $form = $(evt.currentTarget).closest('form');
                $form.find('input:visible').each(function (i, input) {
                    $(input).toggleClass('error', !$(input).val());
                });
                if ($form.find('input.error').length === 0) {
                    formUtils_1.appendAntiforgeryToken($form).then(function ($form) {
                        return $.ajax({
                            url: $form.attr('action'),
                            type: 'POST',
                            data: $form.serialize(),
                            dataType: 'json',
                            headers: { 'X-Requested-With': 'XMLHttpRequest' },
                            crossDomain: true,
                            xhrFields: {
                                withCredentials: true
                            }
                        });
                    }).then(function (resp) {
                        if (resp.errors) {
                            $form.find('p.error').remove();
                            $form.prepend($("<p class='error'></p>").text(resp.errors[0].ErrorMessage));
                        }
                        else if (resp.data) {
                            if (resp.user && (resp.user.credit || resp.user.coupon)) {
                                $dlg.removeData('onCloseNavigate');
                                $dlg.dialog('close');
                                welcomeCredit_1["default"](resp.user.firstName, resp.user.credit, resp.user.coupon);
                            }
                            else {
                                window.location.href = resp.data;
                            }
                        }
                        else if (resp && resp.callback) {
                            var fn = window[resp.callback];
                            if (fn) {
                                fn();
                            }
                        }
                    });
                }
            });
        }
        $dlg.data('onCloseNavigate', onCloseNavigate);
        $dlg.dialog('show');
    }
    exports["default"] = default_1;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/dialogs/emailMissing.js
// module id = 9
// module chunks = 0